import { render, staticRenderFns } from "./ConsultantProfileSummary.vue?vue&type=template&id=c91aaf42&scoped=true&"
import script from "./ConsultantProfileSummary.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConsultantProfileSummary.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConsultantProfileSummary.vue?vue&type=style&index=0&id=c91aaf42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91aaf42",
  null
  
)

export default component.exports